/*eslint-disable*/

(function ($) {
  var GlobalLocationHeader = {
    $header: [],

    init: function($header) {
      this.$header.push($header);

      var me = this;
      $header.bind('location-update', function(e, data) {
        if (data.scope == 'global') {
          me.updateLinkWithAddress($(this), data.data);
          me.display($(this));
          me.closeForm($header);
        }
      });

      var loc = Location.getGlobal();
      if (loc === null) {
        Location.determineGlobalFromBrowser(function(addr) {
          if (!addr) {
            GlobalLocationHeader.display($header);
          }
          else {
            Location.update('global', addr);
          }
        });
      }
      else {
        Location.update('global', loc);
      }

      $('.change-button', $header).on('click', function(e) {
        GlobalLocationHeader.openForm($header);
      });
      $('.close-button', $header).on('click', function(e) {
        $('body').removeClass('display-location-form');
        $header.removeClass('location-form-open');
        $('.header-location-picker-form input', $header).val('');
      });
    },

    openForm: function(context) {
      $('body').addClass('display-location-form');
      context.addClass('location-form-open');
      $('.header-location-picker-form input', context).val('');
      $('.header-location-picker-form input', context).focus();
    },

    closeForm: function(context) {
      $('body').removeClass('display-location-form');
      context.removeClass('location-form-open');
      $('.header-location-picker-form input', context).val('');
    },

    display: function($header) {
      $header.show();
    },

    updateLinkWithAddress: function(context, data) {
      if (!data || data == null || data.zip === null || data.zip.length < 1) {
        var default_label = $('.global-location-header .change-button', context).attr('data-attr-default-label');
        var default_inside_label = $('.header-location-picker-form .label-box label', context).attr('data-attr-default-label');

        $('.change-button .inner-text', context).html(default_label);
        $('.header-location-picker-form .label-box label', context).html(default_inside_label);
        spireAttach(jQuery(context[0]));
      }
      else {
        var format = "__CITY__, __STATE_ABR__ (__ZIP__)";
        var format_attr = context.attr('data-label-format');
        if (typeof format_attr !== 'undefined' && format_attr !== false) {
          format = context.attr('data-label-format');
        }

        var inside_format = "<div>__CITY__, __STATE_ABR__</div><div>ZIP Code __ZIP__</div>";
        var inside_format_attr = context.attr('data-inside-label-format');
        if (typeof inside_format_attr !== 'undefined' && inside_format_attr !== false) {
          inside_format = context.attr('data-inside-label-format');
        }


        var label = format.replace("__CITY__", data.city).replace("__STATE_ABR__", data.state_abr).replace('__ZIP__', data.zip);

        var inside_label = inside_format.replace("__CITY__", data.city).replace("__STATE_ABR__", data.state_abr).replace('__ZIP__', data.zip);

        $('.change-button .inner-text', context).html(label);
        $('.header-location-picker-form .label-box label', context).html(inside_label);
        spireAttach(context[0]);
      }

    }
  }

  Drupal.behaviors.spireLocationAware = {
    attach: function (context, settings) {
      jQuery('.location-picker').each(function() {
        Location.addPicker($(this));
      });

      $('.global-location-header', context).each(function() {
        GlobalLocationHeader.init($(this));
      });

      $('.location-picker', context).focus(
        function() {
          var me = $(this);
          setTimeout(function () {
            if (me.is(':focus')) {
              me.parent('div').addClass('focus');
            }
          }, 0);
        }).blur(
          function() {
            var me = $(this);
            setTimeout(function () {
              if (!me.is(':focus')) {
                me.parent('div').removeClass('focus');
              }
            }, 150);
          });

      $('.location-field', context).once('clear-button').each(function (e) {
        $('.clear-button').on('click', function(e1) {
          e1.preventDefault();

          $(this).prev().val('');
          $(this).prev().trigger('focus');
        });
      });

    }
  };
}(jQuery));
